import * as types from "./actionTypes";
import referentieApi from "../api/shared/referentieApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";

// ----------------------------------------------------------------------------
function referencesLoaded(references) {
	return {
		type: types.REFERENCES_LOADED,
		body: references
	};
}

export function loadReferences() {
	return function (dispatch) {
		dispatch(ajax.started());
		return referentieApi.getAll()
			.then((response) => {
				dispatch(ajax.ended());
				if (!response.data || typeof response.data === 'string')
					dispatch(exception.throwException("No valid reference data from api"));
				else
					dispatch(referencesLoaded(response.data));
			})
			.catch(error => {
				//todo refactor this
				dispatch(ajax.failed());
				dispatch(exception.throwException(error));
			});
	};
}
